export const fileToBase64 = (files: any, cb: Function) => {
    const reader = new FileReader();

    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
        cb(e.target?.result)
    }
}
